type Item = Record<string, any> | string | undefined | null;

export type TClassNameItem = Item | Item[];

export default function classnames(...classes: Item[]): string {
    return classes.reduce((res: string[], item: Item) => {
        let classToPush;
        if (item != null && Array.isArray(item)) {
            classToPush = item.reduce((res: string[], className: string) => {
                if (className != null && (className = String(className)).length) {
                    res.push(className);
                }

                return res;
            }, []).join(' ');
        } else if (item != null && typeof item === 'object') {
            classToPush = Object.keys(item).reduce((res: string[], className: string) => {
                if (item[className] && className.length) {
                    res.push(className);
                }

                return res;
            }, []).join(' ');
        } else {
            classToPush = item;
        }

        if (classToPush != null && classToPush.length) {
            res.push(classToPush);
        }

        return res;
    }, []).join(' ');
}
